import { render, staticRenderFns } from "./moveSales.vue?vue&type=template&id=0d848988"
import script from "./moveSales.vue?vue&type=script&lang=js"
export * from "./moveSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports